import React from 'react'
import Chart from "react-apexcharts";
import CountUp from 'react-countup';
import { Link } from 'react-router-dom';

import CreditCardImg from "../../../assets/images/gallery/credit-card-img.png"
import { TransactionCards } from './Components/TransactionCardData';
import { myExpenseChart } from './Components/MyExpenseChart';
import AllTransactionTable from './Components/AllTransaction/AllTransactionTable';
import IncomeTable from './Components/IncomeTable/IncomeTabTable';
import ExpenseTable from './Components/Expense/ExpenseTable';

const Transaction = () => {
  return (
    <div>
      {/* x---------------------------------x Credit Card/Expence Section x---------------------------------x */}
      <div className="row g-sm-3 g-1">
        {/* x---------------------------------x Credit Card Section x---------------------------------x */}
        {TransactionCards.map((cardData, index) => {
          return (
            <div className="col-xl-4 col-md-6 pe-0" key={index}>
              <div className="card rounded-4 mt-0">
                {
                  cardData.id === 1 ? (
                    <div className={`card-header d-none d-sm-flex ${cardData.h_class}`}>
                      <button
                        className="p-0 m-0 border-0 text-primary text-end fs-5 fw-semibold bg-transparent"
                        type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
                        aria-controls="offcanvasRight">+Add Card</button>
                    </div>
                  ) : (
                    <div className={`card-header ${cardData.h_class}`}>
                      <h3 className={`fs-5 fw-semibold`}>{cardData.heading}</h3>
                    </div>
                  )
                }

                <div
                  className={`${cardData.bg_color} rounded-4`}
                >
                  <div className="card-body rounded-4 rounded-bottom-0">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h5
                          className={`${cardData.text_color} card-title fs-6 fw-normal font-family-Lato`}
                        >
                          Balance
                        </h5>
                        <span
                          className={`${cardData.text_color} card-text fs-3 fw-normal font-family-Lato`}
                        >
                          $ <CountUp end={cardData.value} duration={2.5} start={0} />
                        </span>
                      </div>
                      <div>
                        <div className="card-img">
                          {cardData.cardIcon}
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-4">
                      <div>
                        <h5
                          className={`${cardData.text_color} fs-6 fw-normal font-family-Lato`}
                        >
                          CARD HOLDER
                        </h5>
                        <h4
                          className={`${cardData.text_color} ${cardData.fontsSize}  fw-normal font-family-Lato`}
                        >
                          {cardData.name}
                        </h4>
                      </div>
                      <div>
                        <h5
                          className={`${cardData.text_color} text-opacity-75 fs-6 fw-normal font-family-Lato`}
                        >
                          VALID THRU
                        </h5>
                        <h4
                          className={`${cardData.text_color} fs-3 fw-normal font-family-Lato`}
                        >
                          {cardData.expiry}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer rounded-bottom-4">
                    <div className="d-flex justify-content-between align-items-center py-2">
                      <div>
                        <h4
                          className={`${cardData.text_color} card-text fs-3 fw-normal font-family-Lato`}
                        >
                          {cardData.cardNumber}
                        </h4>
                      </div>
                      <div>
                        <div className="card-img">
                          {cardData.f_icon}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {/*x---------------------------------x My Expense x---------------------------------x // */}
        <div className="col-xl-4 col-md-6">
          <div className="card border-0 bg-transparent h-100">
            <div className="card-header">
              <h3 className="text-dark fs-5 fw-semibold ">My Expense</h3>
            </div>
            <div className="card-body rounded-4 mb-3 mb-sm-0 bg-light">
              <div id="chart" style={{ height: "inherit", minHeight: "inherit", width: "inherit" }}>
                <Chart
                  options={myExpenseChart}
                  series={myExpenseChart.series}
                  type={myExpenseChart.chart.type}
                  height={myExpenseChart.chart.height}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* x---------------------------------x Recent Transactions x---------------------------------x */}
      <div className="row my-2">
        <div className="col-sm-12">
          <div className="card border-0 bg-transparent h-100">
            <div className="card-header justify-content-between">
              <h3 className="text-dark fs-5 fw-semibold mt-sm-3">Recent Transactions</h3>
            </div>
            <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
              <ul className="nav nav-tabs tab-dynamic px-0 mb-4" role="tablist"
                style={{ "--dynamic-color": "var( --primary-color)" }}>
                <li className="nav-item" role="presentation">
                  <Link className="ps-2 pe-3 nav-link active" data-bs-toggle="tab"
                    to="#pills-transactions" role="tab" aria-selected="false" tabIndex="-1">All
                    Transactions</Link>
                </li>
                <li className="nav-item" role="presentation">
                  <Link className="ps-2 pe-3 nav-link " data-bs-toggle="tab" to="#pills-income"
                    role="tab" aria-selected="true">Income</Link>
                </li>
                <li className="nav-item" role="presentation">
                  <Link className="ps-2 pe-3 nav-link" data-bs-toggle="tab" to="#pills-expense"
                    role="tab" aria-selected="false" tabIndex="-1">Expense</Link>
                </li>
              </ul>
              <div className="tab-content" id="pills-tabContent">
                {/* <!-- All Transactions-tab --> */}
                <div className="tab-pane fade show active" id="pills-transactions" role="tabpanel"
                  aria-labelledby="pills-transactions-tab" tabIndex="0">
                  <AllTransactionTable />
                </div>
                {/* <!-- Income-tab --> */}
                <div className="tab-pane fade" id="pills-income" role="tabpanel"
                  aria-labelledby="pills-income-tab" tabIndex="0">
                  <IncomeTable />
                </div>
                {/* <!-- Expense-tab --> */}
                <div className="tab-pane fade" id="pills-expense" role="tabpanel"
                  aria-labelledby="pills-expense-tab" tabIndex="0">
                  <ExpenseTable />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* x---------------------------------x Add Cards offcanvas x---------------------------------x */}
      <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">Add Card</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <div className="row">
            <div className="col-12 ">
              <div className="card bg-transparent p-0 rounded-4">
                <div className="mb-3" style={{ maxWidth: "100%", }}>
                  <div className="row g-0">
                    <div className="col-md-12 ">
                      <div className="card-img h-100">
                        <img src={CreditCardImg}
                          alt="Trendy Pants and Shoes" className="img-fluid" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="card-body">
                        <h5 className="card-title">Benefits that Work for You</h5>
                        <p className="card-text">This is a wider card with supporting text below
                          as a natural lead-in to additional content. This content is a
                          little bit longer.</p>
                        <Link role="button" href="credit-cards.html" className="btn btn-primary">Add
                          Now</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Transaction